export const GET_SUPPORT_ITEMS = "GET_SUPPORT_ITEMS";
export const GET_SUPPORT_ITEM_BY_ID = "GET_SUPPORT_ITEM_BY_ID";
export const UPDATE_SUPPORT_ITEM = "UPDATE_SUPPORT_ITEM";
export const DELETE_SUPPORT_ITEM = "DELETE_SUPPORT_ITEM";
export const CREATE_SUPPORT_ITEM = "CREATE_SUPPORT_ITEM";
